// 页面样式
import css from 'css/page/gift.scss'

// 公共方法
import {
  anotherBatch,
  domObserver,
  headerInit,
  memberShip,
  blkNavTag,
} from 'js/common/index'
// 动画
import {
  swiper,
} from 'js/animation/index'

/**
 * 绑定 DOM 事件
 */
function bindEvts () {
  giftDeliveryInit()
  memberFormInit()
  swipersInit()
  rcmdJump()
  giftRankInit()
}

/**
 * 登录相关表单事件初始化
 */
function memberFormInit() {
  memberShip.closeForm.init()
  memberShip.forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member',
  })
  memberShip.loginFormInit({
    success: () => headerInit(),
    form: '.yui-memberform0-login',
    mask: '.mask-member',
  })
  memberShip.registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member',
  })
}

/**
 * 礼包速递初始化
 */
function giftDeliveryInit () {
  let data = {
    list: '.sec-top .list-container.selected',
    target: '.sec-top .top-rt',
  }

  anotherBatch.init(data)

  // 块切换时，重新绑定“换一批”事件
  blkNavTag.init({
    tagList: '.sec-top .tag-container',
    blkList: '.sec-top .list-containers',
    callback: {
      f: anotherBatch.init,
      data,
    }
  })
}

/**
 * 推荐礼包跳转
 */
function rcmdJump () {
  $('.sec-lft2').on('click', '.btn-download', function (e) {
    e.preventDefault()
    let href = this.getAttribute('data-href')
    window.location.href = process.env.NODE_ENV === 'production' ? href : `${SERVER_URL}${href}`
  })
}

/**
 * 日领/周领礼包排行事件初始化
 */
function giftRankInit () {
  blkNavTag.init({
    tagList: '.sec-rt2 .tag-container',
    blkList: '.sec-rt2 .list-containers',
  })
}

/**
 * 滑块初始化
 */
function swipersInit () {
  // 顶部轮播图
  swiper.init({
    selector: '.swiper0',
    options: {
      pagination: {
        bulletActiveClass: 'selected',
        bulletClass: 'dot',
        clickable: true,
        el: '.swiper-pagination-bullets',
      }
    }
  })

  // 大家都在抢
  swiper.init({
    selector: '.swiper1',
    options: {
      autoplay: {
        delay: 2000,
      },
      direction: 'vertical',
      loop: true,
      slidesPerView: 6,
    }
  })
}

/**
 * UI 初始化
 */
function uiInit () {
}

window._dataBus.get('domReadyObserver').subscribe(() => {
  uiInit()
  bindEvts()
})



// WEBPACK FOOTER //
// ./js/page/gift.js